/** Données de démonstration du menu (secteurs + clients fictifs). */
export const DEMO_SECTORS = [
  { key: 'superette', label: 'Supérette' },
  { key: 'coiffure', label: 'Coiffure' },
  { key: 'boucherie', label: 'Boucherie' },
  { key: 'beaute', label: 'Beauté' },
  { key: 'boulangerie', label: 'Boulangerie' },
  { key: 'huile', label: 'Huile & Épicerie fine' },
  { key: 'opticien', label: 'Opticien' },
  { key: 'vetements', label: 'Vêtements' },
  { key: 'bijouterie', label: 'Bijouterie' },
  { key: 'fleuriste', label: 'Fleuriste' },
  { key: 'kebab', label: 'Kebab' },
  { key: 'tacos', label: 'Tacos' },
  { key: 'pret-a-porter', label: 'Prêt-à-porter' },
  { key: 'ameublement', label: 'Ameublement' },
  { key: 'ludique', label: 'Ludique / Jeux' },
];

export const DEMO_CUSTOMERS = [
  {
    first_name: 'Martin',
    last_name: 'Dupont',
    email: 'martin.dupont@email.fr',
    phone: '06 12 34 56 78',
    loyalty_tier: 'silver',
    loyalty_points: 1246,
    total_spent: 1245.8,
    total_orders: 42,
  },
  {
    first_name: 'Sophie',
    last_name: 'Laurent',
    email: 'sophie.l@email.fr',
    phone: '06 98 76 54 32',
    loyalty_tier: 'gold',
    loyalty_points: 3891,
    total_spent: 3890.5,
    total_orders: 98,
  },
  {
    first_name: 'Pierre',
    last_name: 'Martin',
    email: 'pierre.m@email.fr',
    phone: '07 11 22 33 44',
    loyalty_tier: 'silver',
    loyalty_points: 520,
    total_spent: 520,
    total_orders: 15,
  },
  {
    first_name: 'Julie',
    last_name: 'Rousseau',
    email: 'julie.r@email.fr',
    phone: '06 55 66 77 88',
    loyalty_tier: 'platinum',
    loyalty_points: 6230,
    total_spent: 6230.4,
    total_orders: 156,
  },
  {
    first_name: 'Léo',
    last_name: 'Bernard',
    email: 'leo.b@email.fr',
    phone: '07 22 33 44 55',
    loyalty_tier: 'bronze',
    loyalty_points: 181,
    total_spent: 180.5,
    total_orders: 6,
  },
  {
    first_name: 'Camille',
    last_name: 'Moreau',
    email: 'camille.m@email.fr',
    phone: '06 44 55 66 77',
    loyalty_tier: 'gold',
    loyalty_points: 1580,
    total_spent: 1580,
    total_orders: 45,
  },
  {
    first_name: 'Thomas',
    last_name: 'Petit',
    email: 'thomas.p@email.fr',
    phone: '07 88 99 00 11',
    loyalty_tier: 'bronze',
    loyalty_points: 340,
    total_spent: 340.2,
    total_orders: 11,
  },
  {
    first_name: 'Emma',
    last_name: 'Garcia',
    email: 'emma.g@email.fr',
    phone: '06 77 88 99 00',
    loyalty_tier: 'gold',
    loyalty_points: 4751,
    total_spent: 4750.9,
    total_orders: 120,
  },
];
